import React from 'react'

const Lease = () => {
  return (
    <div>Lease</div>
  )
}

export default Lease